var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-label" }),
        _vm._v(_vm._s(_vm.$t("Label Info")) + " ")
      ]),
      _c(
        "section",
        { staticClass: "searchArea" },
        [
          _c("v-text-field", {
            staticClass: "form-input ml-4",
            style: { width: "13.5%", marginLeft: "0 !important" },
            attrs: {
              label: _vm.$t("Label ID"),
              placeholder: _vm.$t("Input label ID"),
              outlined: "",
              dense: "",
              "hide-details": "",
              clearable: ""
            },
            on: { keyup: _vm.handleSearchLabelIdKeyUp },
            model: {
              value: _vm.searchBy.labelParam,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "labelParam", $$v)
              },
              expression: "searchBy.labelParam"
            }
          }),
          _c("v-text-field", {
            staticClass: "form-input ml-3",
            staticStyle: { width: "15%" },
            attrs: {
              label: _vm.$t("Product ID"),
              placeholder: _vm.$t("Input product ID"),
              outlined: "",
              dense: "",
              "hide-details": "",
              clearable: ""
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.clickSearch()
              }
            },
            model: {
              value: _vm.searchBy.productIdParam,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "productIdParam", $$v)
              },
              expression: "searchBy.productIdParam"
            }
          }),
          _c("v-text-field", {
            staticClass: "form-input ml-3",
            attrs: {
              label: _vm.$t("Product Description"),
              placeholder: _vm.$t("Input product description"),
              outlined: "",
              dense: "",
              "hide-details": "",
              clearable: ""
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.clickSearch()
              }
            },
            model: {
              value: _vm.searchBy.productDescParam,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "productDescParam", $$v)
              },
              expression: "searchBy.productDescParam"
            }
          }),
          _c("v-select", {
            staticClass: "form-select ml-3",
            staticStyle: { width: "150px" },
            attrs: {
              items: _vm.gatewayItems,
              label: _vm.$t("Linked Gateway"),
              placeholder: _vm.$t("Select gateway"),
              clearable: "",
              outlined: "",
              dense: "",
              "persistent-hint": "",
              "hide-details": ""
            },
            model: {
              value: _vm.searchBy.gatewayParam,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "gatewayParam", $$v)
              },
              expression: "searchBy.gatewayParam"
            }
          }),
          _c("v-select", {
            staticClass: "form-select ml-3",
            staticStyle: { width: "150px" },
            attrs: {
              items: _vm.typeItems,
              label: _vm.$t("Type"),
              placeholder: _vm.$t("Select label type"),
              clearable: "",
              outlined: "",
              dense: "",
              "persistent-hint": "",
              "hide-details": ""
            },
            model: {
              value: _vm.searchBy.typeParam,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "typeParam", $$v)
              },
              expression: "searchBy.typeParam"
            }
          }),
          _c(
            "v-btn",
            {
              staticClass: "btn type-search ml-3",
              staticStyle: { width: "120px" },
              attrs: { text: "" },
              on: {
                click: function($event) {
                  return _vm.clickSearch()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Search")) + " ")]
          )
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "searchArea", staticStyle: { width: "60%" } },
        [
          _c("v-select", {
            staticClass: "form-select ml-3",
            staticStyle: { width: "70px" },
            style: { marginLeft: "0 !important" },
            attrs: {
              items: _vm.statusItems,
              label: _vm.$t("Status"),
              placeholder: _vm.$t("Select label status"),
              "item-value": "value",
              "item-text": "text",
              outlined: "",
              dense: "",
              "hide-details": "",
              clearable: ""
            },
            model: {
              value: _vm.searchBy.statusParam,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "statusParam", $$v)
              },
              expression: "searchBy.statusParam"
            }
          }),
          _c("v-text-field", {
            staticClass: "form-input ml-3",
            staticStyle: { width: "70px" },
            attrs: {
              label: _vm.$t("Template Type Name"),
              placeholder: _vm.$t("Input template type name"),
              outlined: "",
              dense: "",
              "hide-details": "",
              clearable: ""
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.clickSearch()
              }
            },
            model: {
              value: _vm.searchBy.templateTypeParam,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "templateTypeParam", $$v)
              },
              expression: "searchBy.templateTypeParam"
            }
          }),
          _vm.CUSTOMER === "LCL" || _vm.CUSTOMER === "METRO"
            ? _c("v-select", {
                staticClass: "form-select ml-3",
                staticStyle: { width: "70px" },
                attrs: {
                  items: _vm.statusItemsBattery,
                  label: _vm.$t("Battery"),
                  placeholder: _vm.$t("Select Battery Level"),
                  "item-value": "value",
                  "item-text": "text",
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                  clearable: ""
                },
                on: { change: _vm.clickCheckBox },
                model: {
                  value: _vm.searchParam.battery,
                  callback: function($$v) {
                    _vm.$set(_vm.searchParam, "battery", $$v)
                  },
                  expression: "searchParam.battery"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "opt-result d-flex justify-end align-center" },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("In-Result Search")))]),
          _vm.LabelAlivestatus
            ? _c("v-checkbox", {
                staticClass: "form-checkbox ml-4",
                attrs: {
                  "hide-details": "",
                  label: "" + _vm.$t("Offline"),
                  value: "false"
                },
                on: { change: _vm.clickCheckBox },
                model: {
                  value: _vm.searchParam.network,
                  callback: function($$v) {
                    _vm.$set(_vm.searchParam, "network", $$v)
                  },
                  expression: "searchParam.network"
                }
              })
            : _vm._e(),
          _vm.CUSTOMER !== "LCL" && _vm.CUSTOMER !== "METRO"
            ? _c("v-checkbox", {
                staticClass: "form-checkbox ml-4",
                attrs: {
                  "hide-details": "",
                  label: "" + _vm.$t("Low Battery"),
                  value: "BAD"
                },
                on: { change: _vm.clickCheckBox },
                model: {
                  value: _vm.searchParam.battery,
                  callback: function($$v) {
                    _vm.$set(_vm.searchParam, "battery", $$v)
                  },
                  expression: "searchParam.battery"
                }
              })
            : _vm._e(),
          _c("v-checkbox", {
            staticClass: "form-checkbox ml-4",
            attrs: {
              "hide-details": "",
              label: "" + _vm.$t("Bad Signal"),
              value: "BAD"
            },
            on: { change: _vm.clickCheckBox },
            model: {
              value: _vm.searchParam.signal,
              callback: function($$v) {
                _vm.$set(_vm.searchParam, "signal", $$v)
              },
              expression: "searchParam.signal"
            }
          }),
          _c("v-checkbox", {
            staticClass: "form-checkbox ml-4",
            attrs: {
              "hide-details": "",
              label: "" + _vm.$t("Misused"),
              value: "All"
            },
            on: { change: _vm.clickCheckBox },
            model: {
              value: _vm.searchParam.misusedLabelType,
              callback: function($$v) {
                _vm.$set(_vm.searchParam, "misusedLabelType", $$v)
              },
              expression: "searchParam.misusedLabelType"
            }
          })
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01",
          attrs: {
            headers: _vm.labelHeaders,
            items: _vm.labelItems,
            "item-class": _vm.getRowClass,
            "hide-default-footer": true,
            "item-key": "id",
            "show-select": "",
            options: _vm.options,
            "items-per-page": 10
          },
          on: {
            "update:options": function($event) {
              _vm.options = $event
            },
            "click:row": _vm.openLabelModal
          },
          scopedSlots: _vm._u(
            [
              {
                key: "item.productdataId",
                fn: function(ref) {
                  var item = ref.item
                  return _vm._l(item.productdataId, function(items, index) {
                    return _c("p", { key: index }, [
                      items.articleId.length > 13
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                items.articleId.substring(0, 4) +
                                  "..." +
                                  items.articleId.substring(
                                    items.articleId.length - 3,
                                    items.articleId.length
                                  )
                              )
                            )
                          ])
                        : items.articleId.length == 0
                        ? _c("span", [_vm._v("-")])
                        : _c("span", [_vm._v(_vm._s(items.articleId))])
                    ])
                  })
                }
              },
              {
                key: "item.productdataName",
                fn: function(ref) {
                  var item = ref.item
                  return _vm._l(item.productdataName, function(items, index) {
                    return _c("p", { key: index }, [
                      items.articletName != null
                        ? _c("span", [
                            items.articletName.length > 12
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      items.articletName.substring(0, 4) +
                                        "..." +
                                        items.articletName.substring(
                                          items.articletName.length - 3,
                                          items.articletName.length
                                        )
                                    )
                                  )
                                ])
                              : items.articletName.length == 0
                              ? _c("span", [_vm._v("-")])
                              : _c("span", [_vm._v(_vm._s(items.articletName))])
                          ])
                        : _c("span", [_vm._v("-")])
                    ])
                  })
                }
              },
              {
                key: "item.battery",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("p", { class: _vm.batteryStyle(item.battery) }, [
                      _vm._v(_vm._s(item.battery))
                    ])
                  ]
                }
              },
              _vm.networklabel
                ? {
                    key: "item.network",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("p", { staticClass: "text-center" }, [
                          _c("i", {
                            staticClass: "state-icon",
                            class: _vm.networkStatusStyle(item.network)
                          })
                        ])
                      ]
                    }
                  }
                : {
                    key: "default",
                    fn: function(undefined) {
                      return [
                        _c("p", { staticClass: "text-center" }, [
                          _vm._v(" " + _vm._s(_vm.item.network) + " ")
                        ])
                      ]
                    }
                  },
              {
                key: "item.status",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("p", { class: _vm.statusStyle(item.status) }, [
                      _vm._v(_vm._s(item.status))
                    ])
                  ]
                }
              },
              {
                key: "item.requestDate",
                fn: function(ref) {
                  var item = ref.item
                  return [_c("span", [_vm._v(_vm._s(item.requestDate))])]
                }
              },
              {
                key: "item.completedDate",
                fn: function(ref) {
                  var item = ref.item
                  return [_c("span", [_vm._v(_vm._s(item.completedDate))])]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")])
          ])
        ],
        2
      ),
      _c("popupLabel", {
        attrs: {
          item: _vm.detailItem,
          labelDetailDisabled: _vm.btnDisabledDetail
        },
        on: { updateLabelList: _vm.searchLabelList }
      }),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "btn",
                attrs: {
                  disabled: _vm.btnDisabledDelete || _vm.checkSelected,
                  text: ""
                },
                on: { click: _vm.unassignLabels }
              },
              [_vm._v(_vm._s(_vm.$t("Unassign")))]
            ),
            _c("BlinkPopup", {
              attrs: {
                selectedLabel: _vm.selectedLabel,
                btnDisabledBlinking:
                  _vm.btnDisabledBlinking || _vm.checkSelected
              }
            }),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled:
                    _vm.btnDisabledExport || _vm.btnDisabledExportCheckList,
                  text: ""
                },
                on: { click: _vm.exportLabelList }
              },
              [_vm._v(_vm._s(_vm.$t("Export")))]
            ),
            _c(
              "v-btn",
              {
                staticClass: "btn  ml-2",
                attrs: {
                  disabled: _vm.btnDisabledDelete || _vm.checkSelected,
                  text: ""
                },
                on: { click: _vm.OnDemandAlive }
              },
              [_vm._v(_vm._s(_vm.$t("On-Demand Alive")))]
            ),
            _vm.CUSTOMER === "LCL"
              ? _c(
                  "v-btn",
                  {
                    staticClass: "btn  ml-2",
                    attrs: {
                      disabled: _vm.btnDisabledDelete || _vm.checkSelected,
                      text: ""
                    },
                    on: { click: _vm.ResendLabelsAssign }
                  },
                  [_vm._v(_vm._s(_vm.$t("Resend")))]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "v-dialog",
              {
                attrs: { width: "300" },
                model: {
                  value: _vm.messageDialog,
                  callback: function($$v) {
                    _vm.messageDialog = $$v
                  },
                  expression: "messageDialog"
                }
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "popup add_store_popup",
                    attrs: { align: "center", justify: "center" }
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c("v-col", [
                          _c("span", {
                            domProps: { textContent: _vm._s(_vm.messageText) }
                          })
                        ])
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      { staticClass: "d-flex justify-center" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn",
                            attrs: { text: "", icon: "" },
                            on: {
                              click: function($event) {
                                ;(_vm.messageDialog = false),
                                  _vm.searchLabelList()
                              }
                            }
                          },
                          [_vm._v("OK")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c("div", { staticClass: "pageInfo" }, [
              _vm._v(_vm._s(_vm.pageInfoText))
            ]),
            _c("v-pagination", {
              staticClass: "pageAlign",
              attrs: {
                length: _vm.pageCount,
                "total-visible": 7,
                color: "#2f3b4c"
              },
              on: { input: _vm.paging },
              model: {
                value: _vm.pageIndex,
                callback: function($$v) {
                  _vm.pageIndex = $$v
                },
                expression: "pageIndex"
              }
            })
          ],
          1
        )
      ]),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }